export default "__VITE_ASSET__b73d5bb1__"